// Legal texts provided by Viral Institution (Hugo Roussel) for the Elevate Influence site.
// Structured for rendering by /app/frontend/src/components/Legal.jsx.

export const LEGAL_CONTENT = {
  "mentions-legales": [
    { h: 2, text: "Éditeur du site" },
    { text: "Le présent site est édité par :" },
    {
      text:
        "Viral Institution\n" +
        "Entreprise individuelle exploitée par Hugo Roussel\n" +
        "SIREN : 992 526 830\n" +
        "Adresse : 60 rue François 1er, 75008 Paris, France",
    },
    { text: "Directeur de publication : Hugo Roussel" },
    {
      text:
        "Pour toute demande, vous pouvez nous contacter à l'adresse indiquée sur la page contact du site.",
    },
    { h: 2, text: "Hébergement" },
    { text: "Le site est hébergé par :" },
    {
      text:
        "OVH SAS\n" +
        "2 rue Kellermann\n" +
        "59100 Roubaix – France",
    },
    { h: 2, text: "Propriété intellectuelle" },
    {
      text:
        "L'ensemble des contenus présents sur ce site (textes, vidéos, visuels, méthodologies, études de cas, logos, éléments graphiques et documents) est protégé par les dispositions du Code de la propriété intellectuelle.",
    },
    {
      text:
        "Toute reproduction, diffusion ou exploitation sans autorisation préalable écrite de Viral Institution est interdite.",
    },
    { h: 2, text: "Responsabilité" },
    { text: "Les informations présentes sur ce site sont fournies à titre informatif." },
    {
      text:
        "Bien que nous nous efforcions de maintenir un contenu exact et à jour, Viral Institution ne garantit ni l'exhaustivité ni l'absence d'erreurs des informations diffusées.",
    },
    {
      text:
        "L'utilisateur reste seul responsable de l'utilisation qu'il fait des contenus et informations présents sur le site.",
    },
  ],
  confidentialite: [
    { h: 2, text: "Notre engagement" },
    { text: "Chez Viral Institution, la confidentialité de vos données n'est pas une option." },
    {
      text:
        "Les informations collectées via nos formulaires, prises de rendez-vous ou échanges commerciaux sont utilisées uniquement dans le cadre de notre relation avec vous.",
    },
    { text: "Nous ne vendons, ne louons et ne cédons jamais vos données personnelles à des tiers." },
    { h: 2, text: "Données collectées" },
    { text: "Nous pouvons être amenés à collecter :" },
    {
      list: [
        "Nom et prénom",
        "Adresse email",
        "Numéro de téléphone",
        "Nom de société",
        "Informations communiquées volontairement via nos formulaires",
      ],
    },
    {
      text:
        "Nous collectons également certaines données techniques nécessaires au bon fonctionnement du site (adresse IP, navigateur, statistiques de navigation).",
    },
    { h: 2, text: "Pourquoi collectons-nous ces données ?" },
    { text: "Ces données nous permettent notamment :" },
    {
      list: [
        "de répondre à vos demandes ;",
        "d'organiser des rendez-vous ;",
        "de proposer nos services ;",
        "d'améliorer l'expérience utilisateur ;",
        "d'assurer le suivi de nos clients.",
      ],
    },
    { h: 2, text: "Vos droits" },
    { text: "Conformément au RGPD, vous disposez à tout moment :" },
    {
      list: [
        "d'un droit d'accès ;",
        "d'un droit de rectification ;",
        "d'un droit d'effacement ;",
        "d'un droit d'opposition ;",
        "d'un droit à la portabilité.",
      ],
    },
    { text: "Pour exercer ces droits, contactez-nous par email." },
  ],
  cgv: [
    { h: 3, text: "1. Présentation" },
    {
      text:
        "Viral Institution accompagne les entrepreneurs, dirigeants et entreprises dans le développement de leur visibilité grâce à la stratégie de contenu, la création vidéo, le personal branding, le marketing digital et le conseil en communication.",
    },
    { h: 3, text: "2. Objet des prestations" },
    { text: "Les prestations peuvent inclure notamment :" },
    {
      list: [
        "stratégie de contenu ;",
        "accompagnement marketing ;",
        "développement de marque personnelle ;",
        "création de vidéos ;",
        "tournage ;",
        "montage ;",
        "consulting ;",
        "publicité digitale ;",
        "audit et conseil.",
      ],
    },
    { text: "Le détail exact de la mission est précisé dans le devis ou le contrat signé avec le client." },
    { h: 3, text: "3. Validation de la mission" },
    { text: "Toute mission débute après :" },
    {
      list: [
        "acceptation du devis ;",
        "signature du contrat si applicable ;",
        "réception du règlement prévu.",
      ],
    },
    { h: 3, text: "4. Conditions financières" },
    { text: "Les modalités de paiement sont indiquées sur le devis." },
    { text: "Sauf mention contraire, les sommes versées ne sont pas remboursables une fois la mission démarrée." },
    { text: "Tout retard de paiement entraîne l'application des pénalités légales en vigueur." },
    { h: 3, text: "5. Résultats" },
    {
      text:
        "Viral Institution met en œuvre son expertise, son expérience et ses ressources afin d'obtenir les meilleurs résultats possibles.",
    },
    {
      text:
        "Toutefois, les performances d'une stratégie de contenu, d'une campagne marketing ou d'une marque personnelle dépendent de nombreux facteurs externes.",
    },
    {
      text:
        "Aucun résultat précis en termes de chiffre d'affaires, nombre de vues, abonnés ou prospects ne peut être garanti.",
    },
    { h: 3, text: "6. Confidentialité" },
    { text: "Les informations échangées entre le client et Viral Institution sont considérées comme confidentielles." },
    { text: "Chaque partie s'engage à ne pas divulguer les informations sensibles obtenues dans le cadre de la mission." },
    { h: 3, text: "7. Propriété intellectuelle" },
    { text: "Sauf disposition contraire prévue contractuellement :" },
    {
      list: [
        "les stratégies ;",
        "frameworks ;",
        "méthodologies ;",
        "documents internes ;",
        "process ;",
      ],
    },
    { text: "restent la propriété exclusive de Viral Institution." },
    { text: "Les contenus produits pour le client deviennent exploitables par celui-ci après règlement intégral des sommes dues." },
    { h: 3, text: "8. Droit applicable" },
    { text: "Les présentes conditions sont soumises au droit français." },
    { text: "Tout litige relèvera de la compétence des juridictions françaises." },
  ],
};
